/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { useSelector } from 'react-redux';

/**
 * Returns all user permissions (organization wide and tenant-wide) for a specific user.
 *
 * @param {String} tenantId The current tenant ID, if any.
 * @returns {Array} The list of all permissions.
 */
const useUserPermissions = (orgId, tenantId) => {
  const { currentUser } = useSelector((state) => state.auth);

  if (currentUser) {
    const tenantRolesByOrganization = currentUser?.effectiveRoles?.tenantRoles?.[orgId] ?? {};

    const tenantRoles = tenantId in tenantRolesByOrganization
      ? tenantRolesByOrganization[tenantId] : [];

    const organizationRoles = currentUser.effectiveRoles?.organizationRoles && orgId in currentUser.effectiveRoles.organizationRoles
      ? currentUser.effectiveRoles.organizationRoles[orgId] : [];

    const allRoles = tenantRoles.concat(organizationRoles);
    return allRoles;
  }

  return [];
};

export default useUserPermissions;
